module.exports = "/images/valentina.jpg";